export class PerfilInversor{
    nombre: string;
    apellidos: string;
    siglas: string;
    saldoWallet?: string;
}